const MuiAppBar = {
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(173, 216, 230, 0.5)'
    }
  }
};

export default MuiAppBar;
//#F6F5F2
